var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        _setup.getComponent.component,
        _vm._b(
          {
            tag: "component",
            staticClass: "crm-drawer",
            class: [
              {
                "shadow-left": _setup.breakpoint.mdAndUp,
                "z-drawer":
                  _setup.usePage().component == "Inbox" &&
                  _setup.breakpoint.smAndDown,
              },
            ],
            model: {
              value: _setup.show,
              callback: function ($$v) {
                _setup.show = $$v
              },
              expression: "show",
            },
          },
          "component",
          { ..._setup.getComponent.props },
          false
        ),
        [
          _c(
            "v-card",
            {
              key: _vm.crmClient?.id,
              staticClass: "crm-card soli-grey",
              class: { "half-round": _setup.breakpoint.smAndDown },
              attrs: { height: "100%" },
            },
            [
              _c(
                "v-container",
                { staticClass: "flex flex-col h-full w-full" },
                [
                  _c(
                    "div",
                    { staticClass: "crm-content safe-bottom" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "modal-close-btn",
                          attrs: { icon: "", color: "dark" },
                          on: {
                            click: function ($event) {
                              return _setup.reset()
                            },
                          },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              _vm._s(
                                !_setup.breakpoint.md ? "close" : "exit_to_app"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-title",
                        {
                          staticClass:
                            "crm-title flex flex-col flex-grow-0 align-start gap-0",
                        },
                        [
                          _c("div", { staticClass: "soli-caption" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  `${
                                    _setup.isLead ? "Lead" : "Client"
                                  } Information`
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          !_setup.loading
                            ? _c(
                                _setup.Link,
                                {
                                  attrs: {
                                    href: _setup.isLead
                                      ? `/dashboard/reports/leads/${_vm.crmClient.id}`
                                      : `/profile/${_vm.crmClient.id}/account`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.crmClient.name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _setup.loading
                            ? _c("v-skeleton-loader", {
                                staticClass: "w-full dense-skeleton",
                                attrs: { type: "card-heading" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _setup.loading
                        ? _c("v-skeleton-loader", {
                            staticClass: "w-full",
                            attrs: { type: "list-item-avatar-three-line" },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_setup.loading && _vm.crmClient?.id
                        ? _c(
                            "div",
                            { staticClass: "crm-body divide-y" },
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "crm-contact-details gap-2" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex items-center" },
                                        [
                                          _c(
                                            "v-list-item-avatar",
                                            [
                                              _vm.crmClient.profile_photo_url ||
                                              _vm.crmClient.profile_photo_path
                                                ? _c("v-img", {
                                                    attrs: {
                                                      src: _vm.crmClient
                                                        .profile_photo_path
                                                        ? `/api/image-service/40x40/${_vm.crmClient.profile_photo_path}`
                                                        : _vm.crmClient
                                                            .profile_photo_url,
                                                    },
                                                  })
                                                : _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        size: "48",
                                                        color: "dark",
                                                      },
                                                    },
                                                    [_vm._v("account_circle")]
                                                  ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "grid" },
                                            [
                                              _c(
                                                "v-list-item-subtitle",
                                                { staticClass: "line-clamp-1" },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(
                                                        _vm.crmClient.email
                                                      ) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-item-subtitle", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.crmClient.phone
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "h-full my-auto" },
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                "min-width": "120",
                                                "offset-y": "",
                                                left: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                            },
                                                            on
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "more_vert"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3491234933
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "v-list",
                                                { attrs: { dense: "" } },
                                                _vm._l(
                                                  _setup.actions.manage,
                                                  function (action) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: action.title,
                                                        class: action.class,
                                                        attrs: {
                                                          disabled:
                                                            !_vm.crmClient
                                                              .belongsToLocation,
                                                        },
                                                        on: {
                                                          click: action.handle,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  action.title
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex gap-4" },
                                    _vm._l(
                                      _setup.actions.communication,
                                      function (action) {
                                        return _c(
                                          "v-btn",
                                          {
                                            key: action.title,
                                            staticClass: "soli-grey",
                                            attrs: {
                                              small: "",
                                              rounded: "",
                                              elevation: "0",
                                              activeClass: "primary--text",
                                              disabled: action.disabled,
                                            },
                                            on: { click: action.handle },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v(_vm._s(action.icon))]
                                            ),
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(action.title) +
                                                "\n                                "
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-expansion-panels",
                                    {
                                      staticClass: "flex flex-col divide-y",
                                      attrs: {
                                        accordion: "",
                                        flat: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value: _setup.panels,
                                        callback: function ($$v) {
                                          _setup.panels = $$v
                                        },
                                        expression: "panels",
                                      },
                                    },
                                    [
                                      _setup.isLead
                                        ? _c(
                                            "v-expansion-panel",
                                            { staticClass: "lead-details" },
                                            [
                                              _c(
                                                "v-expansion-panel-header",
                                                {
                                                  staticClass:
                                                    "soli-grey font-semibold",
                                                },
                                                [
                                                  _vm._v(
                                                    "Inquiry Details\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-expansion-panel-content",
                                                { staticClass: "soli-grey" },
                                                _vm._l(
                                                  _setup.leadDetails,
                                                  function (item, idx) {
                                                    return _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        key: idx,
                                                        staticClass: "flex",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-capitalize",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(idx) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-spacer"),
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(item)
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel",
                                        { staticClass: "lead-relationships" },
                                        [
                                          _c(
                                            "v-expansion-panel-header",
                                            {
                                              staticClass:
                                                "soli-grey font-semibold",
                                            },
                                            [
                                              _vm._v(
                                                "Relationships\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-expansion-panel-content",
                                            {
                                              staticClass:
                                                "flex flex-col divide-y",
                                            },
                                            _vm._l(
                                              _setup.leadRelationships,
                                              function (child) {
                                                return _c(
                                                  "v-list-item-title",
                                                  {
                                                    key: child.id,
                                                    staticClass: "soli-grey",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(child.name) +
                                                        "\n                                            "
                                                    ),
                                                    _vm._l(
                                                      child.details,
                                                      function (item, idx) {
                                                        return _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            key: idx,
                                                            staticClass:
                                                              "flex soli-grey",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "text-capitalize",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      idx
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("v-spacer"),
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(item) +
                                                                "\n                                            "
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel",
                                        [
                                          _c(
                                            "v-expansion-panel-header",
                                            {
                                              staticClass:
                                                "soli-grey font-semibold",
                                            },
                                            [_vm._v("Automation")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-expansion-panel-content",
                                            [
                                              _c(_setup.CRMAutomation, {
                                                attrs: {
                                                  crmClient: _vm.crmClient,
                                                  errors: _vm.errors,
                                                  relationships:
                                                    _setup.leadRelationships,
                                                  disabled:
                                                    !_vm.crmClient
                                                      .belongsToLocation ||
                                                    !_setup.isLead,
                                                },
                                                on: {
                                                  toast: function ($event) {
                                                    _setup.showToast = $event
                                                  },
                                                  hide: function ($event) {
                                                    _setup.show =
                                                      _setup.breakpoint.mdAndUp
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-expansion-panel",
                                        [
                                          _c(
                                            "v-expansion-panel-header",
                                            {
                                              staticClass:
                                                "soli-grey font-semibold",
                                            },
                                            [_vm._v("Notes")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-expansion-panel-content",
                                            [
                                              _c(_setup.CRMNote, {
                                                attrs: {
                                                  crmClient: _vm.crmClient,
                                                  errors: _vm.errors,
                                                  disabled:
                                                    !_vm.crmClient
                                                      .belongsToLocation,
                                                },
                                                on: {
                                                  toast: function ($event) {
                                                    _setup.showToast = $event
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _setup.isLead
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mx-4 justify-self-end",
                          attrs: {
                            small: "",
                            rounded: "",
                            text: "",
                            color: "accent",
                            href: "/dashboard/reports/leads",
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "", left: "" } }, [
                            _vm._v("chevron_left"),
                          ]),
                          _vm._v("All\n                    Leads"),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _setup.showToast
            ? _c("SoliSnack", {
                attrs: {
                  time: 2000,
                  text: _setup.showToast,
                  app: false,
                  maxWidth: "90%",
                },
                on: {
                  hide: function ($event) {
                    _setup.showToast = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.manageLead
            ? _c(_setup.ManageLead, {
                attrs: {
                  leadId: _vm.crmClient?.lead?.id ?? _vm.crmClient.id,
                  errors: _vm.errors,
                },
                on: {
                  reset: function ($event) {
                    return _setup.closeManageLead()
                  },
                  success: function ($event) {
                    return _setup.closeManageLead($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.crmClient.belongsToLocation && !_setup.loading
            ? _c(
                "v-banner",
                {
                  staticClass: "fixed bottom-0 w-full z-more",
                  attrs: {
                    value: true,
                    "single-line": "",
                    app: false,
                    color: "error white--text",
                  },
                },
                [
                  _c("div", { staticClass: "flex justify-center" }, [
                    _vm._v(
                      "\n                Client Changed Locations\n            "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "z-more" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }